import { column, columnCenter, title, link } from './column.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

const Column = ({
  column: column$1
}) => /*#__PURE__*/jsx("section", {
  className: column,
  children: /*#__PURE__*/jsxs("div", {
    className: columnCenter,
    children: [column$1.title && /*#__PURE__*/jsx("h5", {
      className: title,
      children: column$1.title
    }), column$1.links.map(link$1 => /*#__PURE__*/jsx("a", {
      className: link,
      href: link$1.url,
      target: link$1.target || "_blank",
      children: link$1.text
    }, link$1.text))]
  })
});

export { Column };
//# sourceMappingURL=column.casing.js.map
